export default __webpack_public_path__ + "static/media/gallery_07.ed18ef3b.jpg";